// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Detail_loaderContainer__3uG5D"};